import { Star } from 'lucide-react';
import React, { useState } from 'react';

export function Rating({
  value = 0,
  precision = 0.5,
  onChange,
  className = '',
}) {
  const [hoverValue, setHoverValue] = useState(null);
  const displayValue = hoverValue ?? value ?? 0;

  const handleClick = (starIndex, isHalf) => {
    const newValue = starIndex + (isHalf ? 0.5 : 1);
    onChange?.(null, newValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(null);
  };

  return (
    <div className={`rating ${className}`} onMouseLeave={handleMouseLeave}>
      {[0, 1, 2, 3, 4].map((starIndex) => {
        const starValue = starIndex + 1;
        const fillPercentage = Math.min(
          Math.max((displayValue - starIndex) * 100, 0),
          100,
        );

        return (
          <div key={starIndex} className="rating__star">
            <button
              type="button"
              className="rating__half rating__half--left"
              onMouseEnter={() => setHoverValue(starIndex + 0.5)}
              onClick={() => handleClick(starIndex, true)}
            />
            <button
              type="button"
              className="rating__half rating__half--right"
              onMouseEnter={() => setHoverValue(starIndex + 1)}
              onClick={() => handleClick(starIndex, false)}
            />
            <div
              className="rating__icon"
              style={{ '--fill': `${fillPercentage}%` }}
            >
              <Star className="rating__icon-bg" />
              <Star className="rating__icon-fill" />
            </div>
          </div>
        );
      })}
    </div>
  );
}
